"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class PageView extends React.Component {
    render() {
        if (this.props.ready) {
            this.props.children();
        }
        return null;
    }
}
exports.default = PageView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBZ0M7QUFFaEMsTUFBcUIsUUFBUyxTQUFRLEtBQUssQ0FBQyxTQUFtRDtJQUNwRixNQUFNO1FBQ1QsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssRUFBRTtZQUNsQixJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsRUFBRSxDQUFDO1NBQ3pCO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztDQUNKO0FBUEQsMkJBT0MifQ==